import { useAppSelector } from 'app/hooks';
import { SubMenu } from 'features/MenuBook/models';
import { memo } from 'react';
import { Droppable } from 'react-beautiful-dnd';
import ChildSubMenuGroupRow from '../ChildSubMenuGroupRow';
import ChildSubMenuRowList from '../ChildSubMenuRowList';
import { getListStyle } from '../MenuBookEditorModal';

export interface ChildSubMenuGroupRowListProps {
  genreId: number;
  subgenreId: number;
  menuId: number;
  subMenuGroupId: number;
  subMenuId: number;
}

function ChildSubMenuGroupRowList({
  genreId,
  subgenreId,
  menuId,
  subMenuGroupId,
  subMenuId,
}: ChildSubMenuGroupRowListProps) {
  const subMenu = useAppSelector((state) => {
    return state.menuBookEditor.data
      .flatMap((genre) => (genre.id === genreId ? genre.subgenres : []))
      .flatMap((subgenre) => (subgenre.id === subgenreId ? subgenre.menus : []))
      .flatMap((menu) => (menu.id === menuId ? menu.sub_menu_groups : []))
      .flatMap((subMenuGroup) => (subMenuGroup.id === subMenuGroupId ? subMenuGroup.sub_menus : []))
      .find((subMenu) => subMenu.id === subMenuId);
  }) as SubMenu;

  const pathId = `${genreId}-${subgenreId}-${menuId}-${subMenuGroupId}-${subMenu.id}`;

  return (
    <Droppable droppableId={`submenu-${pathId}`} type={`child_sub_menu_group-${pathId}`}>
      {(provided, snapshot) => (
        <div {...provided.droppableProps} ref={provided.innerRef} style={getListStyle(snapshot.isDraggingOver)}>
          {subMenu.child_sub_menu_groups.map((childSubMenuGroup, index) => (
            <ChildSubMenuGroupRow
              key={`child_sub_menu_group-${pathId}-${childSubMenuGroup.id}`}
              genreId={genreId}
              subgenreId={subgenreId}
              menuId={menuId}
              subMenuGroupId={subMenuGroupId}
              subMenuId={subMenuId}
              childSubMenuGroupId={childSubMenuGroup.id}
              index={index}
            >
              <ChildSubMenuRowList
                genreId={genreId}
                subgenreId={subgenreId}
                menuId={menuId}
                subMenuGroupId={subMenuGroupId}
                subMenuId={subMenuId}
                childSubMenuGroupId={childSubMenuGroup.id}
              />
            </ChildSubMenuGroupRow>
          ))}
          {provided.placeholder}
        </div>
      )}
    </Droppable>
  );
}

export default memo(ChildSubMenuGroupRowList);
